import { useEffect, useState } from "react";
import SubjectHeader from "../SubjectHeader/SubjectHeader";
import { useLocation, useNavigate } from "react-router-dom";
import './TestPage.scss';
import Checkbox from '@mui/material/Checkbox';
import images from "../../assets/images";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import ResultsPopup from "../ResultsPopup/ResultsPopup";
import { GET_QUIZ, UPDATE_QUIZ_RESULTS } from "../../pages/Quiz/api/QuizQuery";
import { useLazyQuery, useMutation } from "@apollo/client";
import ToasterWithMessage from "../toaster";
import { useAppSelector } from "../../redux/app/hooks";
import { questions, QuizData } from "../../pages/Quiz/Quiz";
import { GET_ALL_QUESTIONS_BANK, UPDATE_QUESTIONS_BANK_RESULTS } from "../../pages/QuestionBank/api/QuestionsBankQuery";
import { FETCH_POLICY, PATH_ADDRESSES, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR } from "../../utils/constants";

export type Results = {
    qs_id?: string;
    question_id?:string;
    given_option: string;
}

const extractData = (data: questions[],isQuestionBank: boolean) => {    
    return data.filter((item: questions) => item.chosen_option !== undefined && item.chosen_option !== null)
    .map((item: questions) => ({
        qs_id: item.qs_id,
        given_option: item.chosen_option
    }));
};

const calculateCurrentIndex = (data: questions[]) => {
    const temp = data.filter((item: questions) => (
        item.chosen_option != undefined
    ));
    return temp.length === 0 ? 0 : temp.length - 1;
}

const TestPage = () => {
   
    const { state } = useLocation();
    const { Checkbox_checked, Checkbox_outline, Quiz_gif } = images;
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const [openResultsPopup, setResultsPopup] = useState<boolean>(false);
    const navigate = useNavigate();
    const [data, setData] = useState<questions[]>(state.data.questions);
    const [results, setResults] = useState<Results[]>(extractData(state?.data?.questions,state?.isQuestionBank));
    const [currentIndex, setCurrentIndex] = useState<number>(calculateCurrentIndex(state?.data?.questions));
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const { error } = ToasterWithMessage();
    const [quizData, setQuizData] = useState<QuizData[]>([]);
    const [isChanged, setIsChanged] = useState<boolean>(false)


    const [updateResults,{loading:updateLoading}] = useMutation(UPDATE_QUIZ_RESULTS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            getQuiz({
                variables: {
                    input : {
                      cId: selectedClassRoomId,
                      sjId: selectedSubjectId,
                      limit: null,
                      offset: null,
                      qzId: state?.data?.quizId
                    }
                  }
            })
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
                }, 2000);
            }
        }
    });

    useEffect(() => {
        if (state?.isRetry) {
            setResults([]);
            setCurrentIndex(0);
        }
    }, [state?.isRetry]);    

    const [updateQuestionsBankResults,{loading:updateQuestionsBankLoading}] = useMutation(UPDATE_QUESTIONS_BANK_RESULTS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            getAllQuestionsBanks({
                variables: {
                    input : {
                        cId: selectedClassRoomId,
                        fId: state?.data?.fileId,
                        sjId: selectedSubjectId,
                    }
                  }
            })
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    navigate('/student-classroom/ebooks/materials/question-bank');
                }, 2000);
            }
        }
    })

    const [getQuiz,{loading:quizLoading}] = useLazyQuery(GET_QUIZ, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          setQuizData(data?.getAllQuizzes?.allquizzes);
        },
        onError: (err) => {
          error(err?.message);
          if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
            setTimeout(() => {
                navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
            }, 2000);
          }
        }
    })

    const [getAllQuestionsBanks,{loading:questionsbankLoading}] = useLazyQuery(GET_ALL_QUESTIONS_BANK, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          setQuizData(data?.getAllQuestionBanks?.allquestionbanks);
        },
        onError: (err) => {
          error(err?.message);
          if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
            setTimeout(() => {
                navigate('/student-classroom/ebooks/materials/question-bank');
            }, 2000);
          }
        }
    })

    const handleChange = (index: number) => {
        setIsChanged(true)
        const temp = [...results];
        if (temp[currentIndex]) {
            temp[currentIndex].given_option = String.fromCharCode(65 + index);
        } else {
            const newResult: any = {
                given_option: String.fromCharCode(65 + index)
            };
    
            if (state?.isQuestionBank) {
                newResult['question_id'] = data?.[currentIndex]?.question_id;
            } else {
                newResult['qs_id'] = data?.[currentIndex]?.qs_id;
            }
    
            temp.push(newResult);
        }
        setResults(temp);
    };
    

    const onYesButtonClick = () => {
        handleSubmit(true);
        setIsChanged(false)
        setOpenConfirmationPopup(false);
    }
  
    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
        setIsChanged(false)
        navigate(state?.backNavigation?.path, { state: state?.backNavigation?.state })
    }
    
    const handleNext = () => {
        if (currentIndex < data.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    }

    const handleSubmit = async(isContinue:boolean) => {
        if (results.length > 0 ) {
            if(state?.isQuestionBank){
                await updateQuestionsBankResults({
                    variables: {
                       input: {
                        cId: selectedClassRoomId,
                        fId: state?.data?.fileId,
                        sjId: selectedSubjectId,
                        resultInfo: results
                       }
                    }
                });
            }
            else {
                 await updateResults({
                    variables: {
                        cId: selectedClassRoomId,
                        qzId: state?.data?.quizId,
                        sjId: selectedSubjectId,
                        isContinue:isContinue,
                        resultInfo: results
                    }
                });
            }
        }
        if (openConfirmationPopup){
            await navigate(state?.backNavigation?.path, { state: state?.backNavigation?.state })
        }
        else {
            setResultsPopup(true);
        }
    }

    const handleCloseResultPopup = (action: string) => {
        setResultsPopup(false);
        if (action === "close") {
            navigate(state?.backNavigation?.path, { state: state?.backNavigation?.state })
        }
        else if (action === "view") {
            if(state?.isQuestionBank){
                navigate('/student-classroom/question-bank/view', { state: { ...state, data: quizData?.[0],isQuestionBank: true} });
            } else {
                navigate('/student-classroom/quiz/view', { state: { ...state, data: quizData?.[0]} });
            }
        }
    }

    const handleBack = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    }
    
    return (
        <div className="TestPageContainer">
            <SubjectHeader headerName = {state?.title} backgroundColor={state?.backGroundColor} subCategory={state?.isQuestionBank ? state?.data?.filename : state?.data?.quizTitle} headerImage={state?.imageSrc} backNavigation={{ path: state?.backNavigation?.path, state: state?.backNavigation?.state }} tabName={state?.isQuestionBank ? 'Questions Bank' : 'Quiz'} setOpenPopup={setOpenConfirmationPopup} results={results} isChanged={isChanged}/>
            <div className="TestPageInnerContainer">
                <div className="QuestionContainer">
                    <div className="QuestionInnerContainer">
                        <div className="Question">
                           {`${ currentIndex + 1 }. ${ state?.isQuestionBank ? data?.[currentIndex]?.question : data?.[currentIndex]?.qs_info }`}
                        </div>
                        <div className="OptionsContainer">
                        {Object.values(data?.[currentIndex]?.options).map((val: any, index: number) => {                            
                          return (
                          <div className="Options" onClick={() => handleChange(index)}>
                                <div className="OptionCode">{`${String.fromCharCode(65 + index)}.`}</div>
                                <div className="OptionText">{ val } </div>
                                <div className="CheckboxContainer">
                                    <Checkbox
                                        icon={<img src={Checkbox_outline} alt="checkBox"/>}
                                        checkedIcon={<img src={Checkbox_checked} alt="checkedImage"/>}

                                        checked={(results[currentIndex]?.given_option?.charCodeAt(0) - 65) === index}
                                    />
                                </div>
                            </div>
                        )})}
                        </div>
                        <div className="ButtonContainer">
                            <button className={`BackButton ${ currentIndex !== 0 ? "BackButtonActive" : "" }`} onClick={ handleBack }>Back</button>
                            <button className={`NextButton ${ (results[currentIndex]?.given_option) ? "NextButtonActive" : "" }`} onClick={ (data.length - 1 === currentIndex) ? ()=>handleSubmit(false) : handleNext } disabled={ (results[currentIndex]?.given_option) === undefined || updateLoading || quizLoading || updateQuestionsBankLoading || questionsbankLoading}>{(data.length - 1 === currentIndex) ? "Submit" : "Next"}</button>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={state?.isQuestionBank ?`Do you want to submit?`: 'Do you wish to save and continue later?'}
                gifData={ Quiz_gif }
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'195px'}
            />
            {(quizData.length > 0) && (
                <ResultsPopup 
                    open={openResultsPopup}
                    data={quizData?.[0]}
                    isQuestionBank={state?.isQuestionBank}
                    handleClick={handleCloseResultPopup}
                />
            )}
        </div>
    )
}

export default TestPage;